module.exports = __webpack_public_path__ + "static/media/historial.7223992b.svg";